import React, { useState } from 'react';
import PropTypes from 'prop-types';

import PeopleContactFields from 'components/contacts/people/contact_fields';
import CompanyContactFields from 'components/contacts/companies/contact_fields';
import PersonContactForm from 'bundles/leads/person_contact_form';
import CompanyContactForm from 'bundles/leads/company_contact_form';
import { fetchPerson } from './people/api';
import { fetchCompany } from './companies/api';
import {
  addNumber,
  changePrimary, deleteNumber,
  phoneNumberChange
} from 'bundles/leads/helper/person_phone_number';

export default function EditContactForm({
  additionalFields,
  hasCrm,
  id,
  persistAddress,
  type,
  useNewFields = false,
  onChange,
  onLoad,
  onLoading,
  onPersistChange
}) {
  const [contact, setContact] = useState(null);

  function updateContact(updatedContact) {
    setContact(updatedContact);
    onChange(updatedContact);
  }

  function handleBasicCompanyChange(newValue, field) {
    updateContact({ ...contact, [field]: newValue });
  }

  function handleAddressCompanyChange(newValue, field) {
    updateContact({ ...contact, address: { ...contact?.address, [field]: newValue } });
  }

  function handlePersonChange(newValue, field) {
    updateContact({ ...contact, [field]: newValue });
  }

  function phoneNumberPersonFieldChange(id, newValue, field) {
    updateContact({ ...contact, phoneNumbers: phoneNumberChange(id, newValue, field, contact.phoneNumbers) });
  }

  function addPhoneNumber() {
    updateContact({ ...contact, phoneNumbers: addNumber(contact.phoneNumbers) });
  }

  function changePhoneNumberPrimary(id, makePrimary) {
    updateContact({ ...contact, phoneNumbers: changePrimary(id, makePrimary, contact.phoneNumbers) });
  }

  function deletePhoneNumber(id) {
    updateContact({ ...contact, phoneNumbers: deleteNumber(id, contact.phoneNumbers) });
  }

  React.useEffect(() => {
    let contactLoad;

    if (onLoading) onLoading();
    if (type === 'Contacts::Person') {
      contactLoad = fetchPerson(id);
    } else {
      contactLoad = fetchCompany(id);
    }

    contactLoad.then((fetchedContact) => {
      setContact(fetchedContact);
      if (onLoad) onLoad(fetchedContact, !!fetchedContact?.address?.id);
    });
  }, []);

  if (!contact) return null;

  return (
    <React.Fragment>
      {type === 'Contacts::Person' &&
        (useNewFields ? (
          <PersonContactForm
            areFieldsRequired={false}
            person={contact}
            showCompanyName={!hasCrm}
            onAddPhoneNumber={addPhoneNumber}
            onChangePhoneNumberPrimary={changePhoneNumberPrimary}
            onDeletePhoneNumber={deletePhoneNumber}
            onFieldChange={handlePersonChange}
            onPhoneNumberChange={phoneNumberPersonFieldChange}
          />
        ) : (
          <PeopleContactFields
            contact={contact}
            showCompanyName={!hasCrm}
            onChange={updateContact}
          />
        ))
      }
      {type === 'Contacts::Company' &&
        (useNewFields ? (
          <CompanyContactForm
            areFieldsRequired={false}
            company={contact}
            persistAddress={persistAddress}
            onAddressChange={handleAddressCompanyChange}
            onFieldChange={handleBasicCompanyChange}
            onToggleAddressFields={onPersistChange}
          />
        ) : (
          <CompanyContactFields
            contact={contact}
            showAddressFields={persistAddress}
            onChange={updateContact}
            onToggleAddressFields={onPersistChange}
          />
        ))
      }
      {additionalFields}
    </React.Fragment>
  );
}

EditContactForm.propTypes = {
  additionalFields: PropTypes.node,
  hasCrm: PropTypes.bool,
  id: PropTypes.number.isRequired,
  persistAddress: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  useNewFields: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
  onLoading: PropTypes.func,
  onPersistChange: PropTypes.func.isRequired
};